import { AgoraVideoPlayer } from "agora-rtc-react";

import fondoEspera from "./assets/gift/espera.gif";
import logo from "./assets/app-icon.png";

const Video = ({ tracks, users, message, userName, tipoUsuario, generales }) => {
  console.log(fondoEspera);
  return (
    <div className="backgroundVideo" style={{ width: message ? "calc(100%-500px)" : "100%" }}>
      {users.length > 0 ? (
        users.map((user) => {
          if (user.videoTrack) {
            return (
              <div className={message ? "otherPersonVideoChat" : "otherPersonVideo"} style={{ display: "flex", justifyContent: "center" }}>
                <AgoraVideoPlayer
                  key={user.uid}
                  videoTrack={user.videoTrack}
                  style={{
                    height: "100%",
                    width: "100%",
                    borderRadius: "20px",
                    position: "absolute",
                  }}
                />
                <div className="phoneNombre" style={{ position: "absolute", backgroundColor: "black", color: "white", padding: 5, fontWeight: 600, borderRadius: 10 }}>
                  {tipoUsuario === "PACIENTE" ? "MEDICO" : "PACIENTE"}: {tipoUsuario === "PACIENTE" ? generales.medico : generales.paciente}
                </div>
                <div className="logo-div-videollamda">
                  <img className="logo-video" src={logo} alt="logo"></img>
                </div>
              </div>
            );
          } else {
            return (
              <div className="withoutVideo">
                <img className="imgFondo" src={fondoEspera} alt="fondo"></img>
              </div>
            );
          }
        })
      ) : (
        <div className="withoutVideo">
          <img className="imgFondo" src={fondoEspera} alt="fondo"></img>
        </div>
      )}
      <div
        className="firstPersonVideo"
        style={{
          right: message ? "520px" : "20px",
        }}
      >
        <AgoraVideoPlayer
          videoTrack={tracks[1]}
          style={{
            height: "100%",
            width: "100%",
          }}
        />
      </div>
    </div>
  );
};

export default Video;
